import { colors } from '../theme/colors';
import type { Theme } from '@mui/material/styles';
export const TEMPLATE_TABLE_MAX_HEIGHT = '356px';

export function templateTableHeaderCellSx(theme: Theme) {
  return {
    height: '56px',
    padding: '16px 4px 16px 16px',
    backgroundColor: theme.palette.semantic.surface.bg3,
    borderBottom: `1px solid ${theme.palette.divider}`,
    fontWeight: 'bold' as const,
    color: theme.palette.semantic.text.title2,
  };
}

export function templateTableRowCellSx(theme: Theme) {
  return {
    height: '60px',
    borderBottom: `1px solid ${theme.palette.divider}`,
  };
}

// Colors follow the Figma "Apply Template" frames: a solid peach banner in dark mode and a
// pale one in light mode, both with the warning text color and a darker icon in dark mode.
export function templateChangesAlertSx(theme: Theme) {
  const isDark = theme.palette.mode === 'dark';

  return {
    backgroundColor: isDark ? colors.warning[200] : colors.warning[100],
    color: colors.warning[600],
    '& .MuiSvgIcon-root': {
      color: isDark ? colors.warning[700] : colors.warning[600],
    },
  };
}

export function templateUpdatedLabelColor(theme: Theme) {
  return theme.palette.mode === 'dark'
    ? theme.palette.amber[400]
    : colors.warning[600];
}
